const RESOURCE_PATHS = {
  Montserrat: {
    regular: '/static/fonts/Montserrat-Regular.ttf',
    bold: '/static/fonts/Montserrat-Bold.ttf',
    light: '/static/fonts/Montserrat-Light.ttf',
    medium: '/static/fonts/Montserrat-Medium.ttf',
    semibold: '/static/fonts/Montserrat-SemiBold.ttf',
    extrabold: '/static/fonts/Montserrat-ExtraBold.ttf'
  }
} as const

const DEFAULT_FONT_FAMILY = 'Montserrat'

const isFontInitialized: Record<keyof typeof RESOURCE_PATHS, boolean> | {} = {}

Object.keys(RESOURCE_PATHS).forEach(key => {
  isFontInitialized[key as keyof typeof RESOURCE_PATHS] = false
})

export const initializeFonts = async (
  fontFamily: keyof typeof RESOURCE_PATHS = DEFAULT_FONT_FAMILY
) => {
  if (isFontInitialized[fontFamily]) return

  const { Font } = await import('@react-pdf/renderer')

  try {
    const fontPromises = Object.values(RESOURCE_PATHS.Montserrat).map(
      async fontPath => {
        const response = await fetch(fontPath, { method: 'HEAD' })

        if (!response.ok) {
          throw new Error(`Font not found: ${fontPath}`)
        }
      }
    )

    await Promise.all(fontPromises)

    Font.register({
      family: 'Montserrat',
      fonts: [
        { src: RESOURCE_PATHS.Montserrat.regular },
        { src: RESOURCE_PATHS.Montserrat.bold, fontWeight: 'bold' },
        { src: RESOURCE_PATHS.Montserrat.light, fontWeight: 'light' },
        { src: RESOURCE_PATHS.Montserrat.medium, fontWeight: 'medium' },
        { src: RESOURCE_PATHS.Montserrat.semibold, fontWeight: 'semibold' },
        { src: RESOURCE_PATHS.Montserrat.extrabold, fontWeight: 'heavy' }
      ]
    })
    isFontInitialized[fontFamily] = true
  } catch (error) {
    console.error('Failed to initialize fonts:', error)
    throw new Error('Failed to initialize PDF fonts')
  }
}

export const downloadPdf = async (blob: Blob, filename?: string) => {
  const url = URL.createObjectURL(blob)

  try {
    const link = document.createElement('a')

    link.href = url

    if (!filename) {
      link.target = '_blank'
      link.rel = 'noopener noreferrer'
    } else {
      link.download = filename.endsWith('.pdf') ? filename : `${filename}.pdf`
    }

    link.click()
  } finally {
    if (filename) {
      URL.revokeObjectURL(url)
    }
  }
}
